import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../../actions/accountRepDataActions';
import { AccountRep } from '@forwardfinancing/component-library';

export class WrappedAccountRep extends Component {

  componentDidMount() {
    this.props.actions.fetchAccountRepData();
  }

  render() {
    const { userData } = this.props;

    if (userData.id){
      const { accountRepData: { account_representative } } = this.props;

      const name = account_representative && account_representative.full_name;
      const phone = account_representative && account_representative.work_phone;
      // If the account rep does not have a headshot, undefined causes fallback
      // to defualt image.
      const imgSrc = (account_representative && account_representative.img_src)
        || undefined;
      const title = "Account Executive";

      const props = {...account_representative, phone, imgSrc, title, name};

      return <AccountRep {...props}/>;
    } else {
      return null;
    }
  }
}

WrappedAccountRep.propTypes = {
  accountRepData: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  userData: PropTypes.object
};

function mapStateToProps(state){
  return {
    accountRepData: state.accountRepData,
    userData: state.userData
  };
}

function mapDispatchToProps(dispatch){
  return{
    actions: bindActionCreators(actions, dispatch)
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WrappedAccountRep);
